import React from "react";

const ClinicalServiceCardToolTip = ({
  noteTitle = "",
  noteSubTitle = "",
  noteDescription = "",
}) => {
  return (
    <div className="bg-white max-w-[460px]">
      {noteTitle != "" && (
        <div className="flex justify-center bg-gray-20 font-semibold text-[18px] text-teal-300 p-6">
          <p className="text-center">{noteTitle}</p>
        </div>
      )}
      {(noteSubTitle != "" || noteDescription != "") && (
        <div className="flex flex-col gap-3 p-6">
          {noteSubTitle != "" && (
            <h3 className=" font-bold text-teal-300 text-sm-body">
              {noteSubTitle}
            </h3>
          )}
          {noteDescription != "" && (
            <h3 className=" text-teal-300 text-sm-body prose-a:underline ">
              {noteDescription}
            </h3>
          )}
        </div>
      )}
    </div>
  );
};

export default ClinicalServiceCardToolTip;
